export const restoreScrollPositionOnBlur = (): (() => void) | undefined => {
  // iOS Safari viewport fix for keyboard dismissal
  if (typeof window !== 'undefined' && window.visualViewport) {
    let lastHeight = window.visualViewport.height;

    const handleResize = () => {
      const currentHeight = window.visualViewport!.height;

      // Keyboard is closing (viewport height is increasing)
      if (currentHeight > lastHeight) {
        // Force scroll to top
        window.scrollTo(0, 0);
        document.body.scrollTop = 0;
        document.documentElement.scrollTop = 0;

        // Force a repaint/reflow
        requestAnimationFrame(() => {
          window.scrollTo(0, 0);
        });
      }

      lastHeight = currentHeight;
    };

    window.visualViewport.addEventListener('resize', handleResize);

    // Cleanup function
    return () => {
      window.visualViewport?.removeEventListener('resize', handleResize);
    };
  }

  // Fallback for browsers without visualViewport API
  let skipScrollReset = false;

  const attachListeners = () => {
    document.querySelectorAll("input, textarea").forEach((input) => {
      // Remove old listeners if any
      input.removeEventListener("focus", handleFocus as any);
      input.removeEventListener("blur", handleBlur as any);

      input.addEventListener("focus", handleFocus as any);
      input.addEventListener("blur", handleBlur as any);
    });
  };

  const handleFocus = () => {
    skipScrollReset = true;
    setTimeout(() => {
      skipScrollReset = false;
    }, 200);
  };

  const handleBlur = () => {
    setTimeout(() => {
      if (!skipScrollReset) {
        window.scrollTo(0, 0);
        document.body.scrollTop = 0;
        document.documentElement.scrollTop = 0;
      }
    }, 300);
  };

  attachListeners();

  // Re-attach listeners periodically for dynamically added inputs
  const intervalId = setInterval(attachListeners, 1000);

  // Cleanup function
  return () => {
    clearInterval(intervalId);
  };
};
